import { IssueType, IssueDetail } from "models/issue";
import { expandedMissingAttributeIssueType, missingAttributeIssueType } from "./definitions/MissingAttribute";
import { expandedMissingEmailIssueType, missingEmailIssueType } from "./definitions/MissingEmail";
import { missingMessageServiceIssueType } from "./definitions/MissingMessageService";
import { expandedMissingSlackUserIssueType, missingSlackUserIssueType } from "./definitions/MissingMessageServiceUser";
import { unassignedRoleIssueType } from "./definitions/UnassignedRole";
import { missingChannelIssueType } from "./definitions/MissingChannel";
import { undeliveredResolutionIssueType } from "./definitions/Undelivered";
import { unauthorizedMessageSenderIssueType } from "./definitions/UnauthorizedMessageSender";
import { deactivatedSenderIssueType } from "./definitions/DeactivatedSender";
import { deactivatedRecipientIssueType } from "./definitions/DeactivatedRecipient";

export const ISSUE_TYPE_MAP: Record<IssueType, (issue: IssueDetail) => string> = {
  missing_channel_membership: missingChannelIssueType,
  missing_attribute: missingAttributeIssueType,
  missing_email: missingEmailIssueType,
  missing_message_service: missingMessageServiceIssueType,
  missing_message_service_user: missingSlackUserIssueType,
  undelivered: undeliveredResolutionIssueType,
  unassigned_role: unassignedRoleIssueType,
  unauthorized_message_sender: unauthorizedMessageSenderIssueType,
  deactivated_sender: deactivatedSenderIssueType,
  deactivated_recipient: deactivatedRecipientIssueType,
};

export default function resolveIssueType(issue: IssueDetail): string | undefined {
  if (!issue) {
    return undefined;
  }
  const issueType = ISSUE_TYPE_MAP[issue.issueType];
  if (!issueType) {
    throw new Error(`Unknown issue type: ${issue?.issueType} for issue ${issue?.id}`);
  }
  return issueType(issue);
}

export const EXPANDED_ISSUE_TYPE_MAP: Partial<Record<IssueType, (issue: IssueDetail) => string>> = {
  missing_email: expandedMissingEmailIssueType,
  missing_message_service_user: expandedMissingSlackUserIssueType,
  missing_attribute: expandedMissingAttributeIssueType,
};

export function expandedIssueTypeResolver(issue: IssueDetail): ((issue: IssueDetail) => string) | undefined {
  if (!issue) {
    return undefined;
  }
  return EXPANDED_ISSUE_TYPE_MAP[issue.issueType];
}
